import { cn } from "@newxsystems/shared";
import type { IBackgroundContainerBlockProps } from "./BackgroundContainerBlock.props";

const backgrounds: Record<string, string> = {
  canvas: "abyss-background-mineral",
  paper: "abyss-background-mineral",
  mint: "bg-primary text-primary-foreground",
  blue: "abyss-background-fog",
  violet: "abyss-background-ink",
  dots: "abyss-background-mineral",
};

export const BackgroundContainerBlock = ({
  background,
  components,
  parentClass,
}: IBackgroundContainerBlockProps) => {
  if (!components) return null;

  return (
    <div
      className={cn(background ? backgrounds[background] : backgrounds.canvas, parentClass)}
      data-background={background || "canvas"}
      data-background-container=""
    >
      {components}
    </div>
  );
};

BackgroundContainerBlock.displayName = "Block::BackgroundContainerBlock";
